module.exports = __webpack_public_path__ + "img/8-full-lg.d41bb14a.jpg";